// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"144":"04af34ae","840":"dfcdd040"}[chunkId] + ".js";
};